import {WinPresentationController} from "../WinPresentationController";
import {TimelineLite, TweenLite} from "gsap";
import {TheRave} from "../../TheRave";
import {TheRaveSymbol} from "../../symbol/TheRaveSymbol";
import {TheRaveSymbolState} from "../../symbol/TheRaveSymbolConfig";
import {TheRaveSound} from "../../sound/TheRaveSound";

export class TransformLowToWild extends WinPresentationController {

    private _tl: TimelineLite;
    private _lowToWildPos: number[][];

    constructor() {
        super("TransformLowToWild", true);
    }

    protected hasWin(): boolean {
        this._lowToWildPos = [];
        if (!TheRave.model.parsedGameData.isFreespin) {
            return false;
        }

        TheRave.model.parsedGameData.doLowToWildReels.forEach((hasTransform: boolean, i: number) => {
            if (hasTransform && !TheRave.model.parsedGameData.doDoubleXways[i]) {
                TheRave.model.reels[i].forEach((symbol: string, j: number) => {
                    if ((j === 1 || j === 2) && symbol[0] === "L") {
                        this._lowToWildPos.push([i, j]);
                    }
                });
            }
        });
        return (this._lowToWildPos.length > 0);
    }

    protected async createWinAnimation(): Promise<void> {
        const tl: TimelineLite = new TimelineLite();

        this._lowToWildPos.forEach((pos: number[], i: number) => {
            const x: number = pos[0], y: number = pos[1],
                transformAnimation: TimelineLite = new TimelineLite();
            const currentSymbol: TheRaveSymbol = TheRave.reels[x].getSymbol(y, true),
                newSymbol: TheRaveSymbol = TheRave.reels[x].createSymbol("W", x, TheRaveSymbolState.NORMAL, currentSymbol.symbolHeight);
            newSymbol.alpha = 0;
            transformAnimation.add([
                () => {
                    TheRave.reels[x].reelView.addSymbol(newSymbol);
                    newSymbol.position.set(currentSymbol.x, currentSymbol.y);
                },
                newSymbol.playTransform()
            ]);
            transformAnimation.add(() => {
                newSymbol.alpha = 1;
                TheRave.reels[x].removeOldSymbol(newSymbol, currentSymbol, y)
            });
            tl.add(transformAnimation, 0);
        });
        tl.add(()=>TheRaveSound.playSoundEffect("wildConvert"),0);

        tl.to(this, {duration: 0.1});
        this._tl = tl;
        await Promise.resolve(tl);
    }


    public skip(): void {
        this._tl.timeScale(2);
    }
}
